import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Grid, Paper, Box } from '@mui/material';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ValidationError } from '../ValidationError';
import { LANGUAGES } from '../../constants';

export const PromotionDescription = ({ 
  formData, 
  onInputChange,
  errors = {}
}) => {
  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
          Полное описание акции
        </Typography>
        <Grid container spacing={3}>
          {LANGUAGES.map(lang => {
            const fieldName = `full_description_${lang.value}`;
            const hasError = !!errors[fieldName];
            
            return (
              <Grid item xs={12} key={lang.value}>
                <Box>
                  <Paper 
                    elevation={1} 
                    sx={{ 
                      p: 2, 
                      borderRadius: 2,
                      border: hasError ? '2px solid #f44336' : 'none'
                    }}
                  >
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 500, color: 'text.primary' }}>
                      Полное описание ({lang.label})
                    </Typography>
                    <Editor
                      editorState={formData[fieldName] || EditorState.createEmpty()}
                      onEditorStateChange={(editorState) => 
                        onInputChange(fieldName, editorState)
                      }
                      toolbar={{
                        options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'link', 'image', 'history'],
                        inline: { inDropdown: true },
                        list: { inDropdown: true },
                        textAlign: { inDropdown: true },
                        link: { inDropdown: true },
                        history: { inDropdown: true },
                      }}
                      wrapperStyle={{ 
                        border: hasError ? '1px solid #f44336' : '1px solid #e0e0e0', 
                        borderRadius: '8px',
                        overflow: 'hidden'
                      }}
                      editorStyle={{ 
                        minHeight: '250px', 
                        padding: '16px',
                        fontSize: '14px'
                      }}
                    />
                  </Paper>
                  <ValidationError error={errors[fieldName]} />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};

PromotionDescription.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object
};
